import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Paintbrush, Square, Palette, Grid3X3, PanelTop, Home, ArrowRight, TrendingUp, Layers } from 'lucide-react';
import { CardStats } from '@components/ui';
import { getAlciSivaStats } from '@mocks/materials/alciSiva';
import { getBoyaStats } from '@mocks/materials/boya';
import { getSeramikStats } from '@mocks/materials/seramik';
import { getKapiPencereStats } from '@mocks/materials/kapiPencere';
import { getCatiStats } from '@mocks/materials/cati';
import { getParkeStats } from '@mocks/materials/parke';
import { formatCurrency } from '../components/StockIndicator';

const subCategories = [
    { key: 'alci-siva', label: 'Alçı / Sıva', path: '/insaat/ince/alci-siva', icon: Square, color: 'bg-neutral-500', description: 'Sıva ve alçıpan takibi' },
    { key: 'boya', label: 'Boya', path: '/insaat/ince/boya', icon: Palette, color: 'bg-warning', description: 'İç ve dış cephe boya takibi' },
    { key: 'seramik', label: 'Seramik / Fayans', path: '/insaat/ince/seramik', icon: Grid3X3, color: 'bg-secondary', description: 'Yer ve duvar seramiği takibi' },
    { key: 'kapi-pencere', label: 'Kapı / Pencere', path: '/insaat/ince/kapi-pencere', icon: PanelTop, color: 'bg-tertiary', description: 'PVC ve iç kapı montaj takibi' },
    { key: 'cati', label: 'Çatı / Kiremit', path: '/insaat/ince/cati', icon: Home, color: 'bg-error', description: 'Çatı malzemesi ve kiremit takibi' },
    { key: 'parke', label: 'Parke', path: '/insaat/ince/parke', icon: Layers, color: 'bg-tertiary', description: 'Laminat, masif ve engineered parke takibi' },
];

export default function InceIsler() {
    const { selectedConstruction, showAllConstructions } = useSelector((state) => state.construction);
    const insaatId = showAllConstructions ? null : selectedConstruction?.id;

    const alciStats = getAlciSivaStats(insaatId);
    const boyaStats = getBoyaStats(insaatId);
    const seramikStats = getSeramikStats(insaatId);
    const kapiStats = getKapiPencereStats(insaatId);
    const catiStats = getCatiStats(insaatId);
    const parkeStats = getParkeStats(insaatId);

    const toplamMaliyet = alciStats.toplamMaliyet + boyaStats.toplamMaliyet + seramikStats.toplamMaliyet + kapiStats.toplamMaliyet + catiStats.toplamMaliyet + parkeStats.toplamMaliyet;

    return (
        <div className="p-4 md:p-6 space-y-6">
            <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-secondary flex items-center justify-center">
                    <Paintbrush size={24} className="text-white" />
                </div>
                <div>
                    <h1 className="text-2xl font-bold text-text-primary">İnce İşler</h1>
                    <p className="text-text-secondary">
                        {showAllConstructions ? 'Tüm İnşaatlar' : selectedConstruction?.name || 'Seçili proje yok'}
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <CardStats title="Seramik" value={`${seramikStats.toplamMetrekare} m²`} icon={Grid3X3} color="secondary" />
                <CardStats title="Boya" value={`${boyaStats.toplamMetrekare} m²`} icon={Palette} color="warning" />
                <CardStats title="Kapı/Pencere" value={`${kapiStats.toplamAdet} adet`} icon={PanelTop} color="tertiary" />
                <CardStats title="Toplam Maliyet" value={formatCurrency(toplamMaliyet)} icon={TrendingUp} color="primary" />
            </div>

            <div>
                <h2 className="text-lg font-semibold text-text-primary mb-4">Malzeme Kategorileri</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {subCategories.map((cat) => {
                        const Icon = cat.icon;
                        return (
                            <Link key={cat.key} to={cat.path}
                                className="group bg-bg-secondary rounded-xl p-5 border border-border-light hover:shadow-lg hover:border-primary/30 transition-all">
                                <div className="flex items-start justify-between">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-12 h-12 rounded-xl ${cat.color} flex items-center justify-center`}>
                                            <Icon size={24} className="text-white" />
                                        </div>
                                        <div>
                                            <h3 className="font-semibold text-text-primary group-hover:text-primary transition-colors">{cat.label}</h3>
                                            <p className="text-sm text-text-muted mt-1">{cat.description}</p>
                                        </div>
                                    </div>
                                    <ArrowRight size={20} className="text-text-muted group-hover:text-primary transition-colors" />
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
